// ** Custom Components
import Block from "components/layout/Block";

// ** Third Party
import { useTranslation } from "react-i18next";

// ** Location Chips Components
import LocationsListingLink from "./components/LocationsListingLink";
import LocationLink from "./components/LocationLink";

// ** Styled Components
import { StyledArrow } from "components/other/styles";

// #####################################################

const LocationChipsAllWorldLevel = () => {
	const { t } = useTranslation(["common"]);
	// #####################################################

	return (
		<Block flex flexWrap>
			{/* Link 'Użytkownikcy / Lokalizacje */}
			<LocationsListingLink isBold />
			{/* Linki Lokalizacyjne Krajów */}
			<StyledArrow />
			<LocationLink
				to={"/search"}
				name={t("common:allWorldLocations")}
				isLast
				isBold
			/>
		</Block>
	);
};

export default LocationChipsAllWorldLevel;
